var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3,41.1c-3.7-1.9-51.1,37.6-51.1,66.6c0,39.7,55.3,129.6,64.6,164.4c8,29.8-13.6,65.6-7.7,67.3 c5.4,3.5,57-49.2,59.1-71.6c2.6-35.8-60.3-140.1-65.3-167.1C57,69.4,67.4,41.8,63.3,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5,0.1c-4.7-2.4-65.2,47.9-65.2,85c-0.1,50.6,70.5,165.3,82.4,209.6c10.2,38.1-17.3,83.7-9.8,85.8 c7,4.5,72.7-62.7,75.3-91.4c3.3-45.6-76.8-178.6-83.2-213C173.5,36.1,186.8,1,181.5,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5,41.1c-3.7-1.9-51.1,37.6-51.1,66.6c-0.1,39.7,55.2,129.6,64.6,164.4c8,29.8-13.6,65.6-7.7,67.3 c5.4,3.5,57-49.2,59.1-71.6c2.6-35.8-60.3-140.1-65.3-167.1C297.3,69.4,307.6,41.8,303.5,41.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gas-icon.f7a56d83625f9019f5ec3ba548a0fdc3.svg";
export { ForwardRef as ReactComponent };